// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> the-deryn
// Generated: 2026-10-12T19:38:12.597Z
// Counts: 5 design, 94 content, 28 slot group, 6 collection binding, 9 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "VALUE",
    "value": "#00306b ",
    "mappedField": null
  },
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#00306b ",
    "mappedField": null
  },
  "design._site.color.linkVisited": {
    "cssVariable": "--vibe-color-link-visited",
    "overrideType": "VALUE",
    "value": "#00306b ",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Private bedrooms, individual leases, and flexible floor plans designed around your lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Private bedroom. Shared apartment. Individual lease. </h2><h2>The Deryn Is Now Leasing In <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Co-Living Made Simple</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Deryn in Gainesville, GA, your lifestyle thrives amid vibrant local attractions. Unwind at Lanier Point Park, engage in fitness at Planet Fitness, or catch an event at the Northeast Georgia History Center. With <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one and three-bedroom floor plans</a>, your perfect home awaits in a bustling neighborhood full of life.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Affordable Living In Gainesville, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>How Co-Living Works</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019ddf84-473f-722e-85c3-eab373e682a2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at The Deryn is designed to be comfortable, convenient, and affordable. Unwind by the resort-style pool, stay active in the fitness center, gather with friends around the fire pits, or enjoy the comfort of modern apartment finishes—all in a <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/featuring/pet-friendly-apartments-gainesville-ga\">pet-friendly apartments</a> just minutes from the University of North Georgia and everything Gainesville has to offer.</p><p></p><p>We invite you to <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/gallery\">immerse yourself in a vibrant lifestyle</a> at The Deryn in Gainesville, GA!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you're searching for the privacy of your own apartment or the affordability of a private bedroom with shared living spaces, The Deryn in Gainesville, GA has a floor plan designed for your lifestyle. Our friendly leasing team is here to help you explore your options and find the perfect place to call home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Affordable Private Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a closer look at modern interiors, welcoming amenities, and comfortable shared spaces.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.title": {
    "overrideType": "VALUE",
    "customValue": "<p>A Community You Will Love</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card3.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Live close to UNG, Brenau University, Northeast Georgia Medical Center, shopping, dining, and Lake Lanier.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card3.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Minutes From Everything</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\"><strong>Flexible Leasing Options</strong></span></h2><p>Whether you're looking for your own private bedroom or planning to live with friends or family, The Deryn offers options designed to fit your lifestyle.</p><ul><li><p><strong>Lease by the Bedroom</strong> — Enjoy a private bedroom with shared common spaces and the convenience of an individual lease.</p></li><li><p><strong>Lease the Entire Apartment</strong> — Looking to move in with roommates, friends, or family? Ask our leasing team about leasing an entire apartment together.</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Deryn in Gainesville, GA, indulge in a lifestyle that blends comfort and convenience. With spacious <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one and three-bedroom floor plans</a>, a vibrant swimming pool, and cozy fire pits, your ideal home awaits. Picture yourself in our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/pet-policy\">pet-friendly community</a>, just a half-mile from campus, where every detail caters to your lifestyle!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "guidedtourbox.knock_button": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_tour_button_popup"
  },
  "featuring/pet-friendly-apartments-gainesville-ga::hyperlocalpagecopy.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Deryn, where we embrace <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/pet-policy\">pet-friendly </a>living in Gainesville, GA, offering an inviting community that welcomes you and your beloved pets. Our prime location offers easy access to a variety of local parks and walking trails, perfect for leisurely strolls with your furry companions. With our spacious floor plans and modern amenities, both you and your pets can enjoy a relaxing and comfortable lifestyle.</p><p>At The Deryn, we believe that pets are family too. <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/\">Our community</a> is designed with pet lovers in mind, and our amenities prove it. Enjoy a swim in our pool or a workout in our fitness center while knowing all household members are welcome, including those with paws. Cable and internet are included, so you can keep everyone entertained, whether it's streaming your favorite shows or catching up on the latest pet videos together.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Tucked away in one of Gainesville's most convenient locations, The Deryn offers the perfect balance of affordability, privacy, and accessibility. Just minutes from the University of North Georgia, Brenau University, Northeast Georgia Medical Center, shopping, dining, and everyday essentials, you'll enjoy a location that keeps you connected without stretching your budget. Whether you're a student, young professional, or simply looking for a smarter way to live, The Deryn makes it easy to feel right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Deryn, we know pets are part of the family, and we’re happy to welcome them in select apartment homes throughout our community. Our thoughtfully designed residences and<a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\"> amenities </a>are created to ensure both you and your furry companion feel comfortable and at home. Pet eligibility varies by apartment type. Select residences, including our co-living homes, allow one (1) pet per private room with management approval. Furnished apartment homes are not pet-eligible. For additional details or to confirm availability, <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/contact\">contact our leasing team</a> is always happy to assist.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Cats and dogs are allowed. One-time pet fee per pet: $500–$1,000. Pet eligibility varies by apartment type. Rent is $35 per pet. Select residences, including our co-living homes, allow one (1) pet per private room with management approval.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Please<a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/contact\"> call our Leasing Office </a>for complete Pet Policy information.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerprogram.employers_list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>First Responders</p></li><li><p>Educators</p></li><li><p>Military &amp; Veterans</p></li><li><p>Law Enforcement</p></li><li><p>Delta Airlines</p></li><li><p>Medical Personnel</p></li><li><p>School System Employees</p></li><li><p>Amazon Fulfillment Center</p></li><li><p>Chik-fil-la</p></li><li><p>Postal Workers</p></li><li><p>Jackson EMC</p></li><li><p>Government Employees</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Deryn, you lease <strong>your own private bedroom—not the entire apartment.</strong></p><p>✔ Individual Lease</p><p>✔ Private Bedroom</p><p>✔ Shared Kitchen &amp; Living Room</p><p>✔ You're only responsible for your own rent</p><p>Perfect for students, young professionals, healthcare employees, and anyone looking for affordable, flexible living.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Deryn in Gainesville, GA, where luxury meets convenience. Choose from our thoughtfully designed <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one and three-bedroom floor plans</a> to suit your lifestyle. Access your resident portal effortlessly to pay rent, schedule maintenance, and enjoy all the benefits of community living. Your new home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Deryn in Gainesville, GA, our thoughtfully designed one- and three-bedroom floor plans blend comfort and style, catering to every lifestyle. Ready to see firsthand what makes our community special? Schedule a tour today, and hear directly from our residents about their amazing experiences living here. <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/contact\">Contact us!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.tour.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.tour.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore thoughtfully designed floor plans that fit your lifestyle—from private one-bedroom apartments to affordable private-bedroom options with shared living spaces.</p><p></p><p>Take a virtual tour and discover why The Deryn is one of Gainesville's best-kept secrets for comfortable, flexible, and affordable living.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f959e-dc27-706c-a5bb-d55db2d81ecf.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A diverse group of friends waving and having fun at a lively summer pool party."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-2935-752a-9d0b-a163820f566c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Office reception area with desks, seating, and a large blue abstract mural."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "ctasection.card3_image": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-1923-742d-aa60-da6c3f1cf933.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with gray sectional sofa, coffee table, TV, and abstract art."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d620a-39bf-742d-9d10-0ef4ad3e36f9.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f196f-f76f-71dd-b5d3-76be329d7202.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-2f3f-7251-bfcc-3c68af037528.webp"
      }
    }
  },
  "footer.facebook_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.facebook.com/people/Live-At-The-Deryn/61591723175360/"
      }
    }
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-477d-72cf-8759-88a68bf2659f.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[10].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[10].image_media.alt_text"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-477d-72cf-8759-88a68bf2659f.webp"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019fb3bc-98e1-70fd-a404-a7bfa495b906.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fun-filled pool party with diverse friends enjoying colorful floats together."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019fb3b9-e8a6-704f-899d-c1f693477dd2.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Man enjoying a sunny day walking his Labrador dog in a peaceful park setting."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[18].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[18].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f959e-2b35-7608-b990-e5872187f663.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A lively outdoor festival scene with people enjoying a picnic at sunset."
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f9593-674e-716d-8e74-a82149feb816.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A Bengal cat and Yorkshire Terrier playfully reach for a feathered toy indoors."
      }
    }
  },
  "preferredemployerprogram.benefit_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Skip the application fee when you show proof of employment from a preferred employer."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Waived Application Fee"
      }
    }
  },
  "preferredemployerprogram.benefit_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Waived Admin"
      },
      "description": {
        "type": "VALUE",
        "customValue": "The administrative fee is waived for qualifying preferred employer applicants."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d620a-d24e-711e-be15-bba9a668d361.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white cabinets, granite countertops, stainless steel sink, black refrigerator, and black stove."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 20,
    "hiddenIds": [
      "custom_56763015-c43e-423d-b94c-5e81b97b0df4",
      "custom_7f9f639f-c241-466d-bf76-a044c0d31f9f",
      "custom_b304d9c2-f56d-4611-a791-3b2df62cd40c",
      "custom_8e4bea73-7a2b-46f2-8b70-bc8d149dff28",
      "custom_cd8e97a3-423b-4182-9364-1178b58e440d"
    ],
    "orderedIds": [
      "custom_fcb6a472-ae49-439c-9a60-0c4b9b33bf71",
      "custom_f4d6554b-f659-444e-87c9-e0bac1a0b72f",
      "custom_3f6179f8-652c-4192-b59f-f3e1d71c7466",
      "custom_35d6de51-6468-4808-adc9-4628b3bb05ad",
      "custom_08e03431-b3fd-4ac2-b2a4-edbae5abe776",
      "custom_96549e32-7188-4ea9-b057-c590247a8a24",
      "custom_429f08c1-d402-4e44-8abe-276111b4f923",
      "custom_57f0f0fc-b7ee-4490-a74d-faeb8fd7882a",
      "custom_83c1671e-d606-4dfa-9a47-5784f1f5cadd",
      "custom_f3dec579-7ffb-4496-9ca0-8b591bd2f5e1",
      "custom_4b4b980d-eb01-4878-a288-32202ddd5a72",
      "custom_8e4bea73-7a2b-46f2-8b70-bc8d149dff28",
      "custom_7f9f639f-c241-466d-bf76-a044c0d31f9f",
      "custom_b304d9c2-f56d-4611-a791-3b2df62cd40c",
      "custom_1a836d3b-50b9-4bf0-879a-03af92997eff",
      "custom_346055df-0b08-4c63-89c0-bbc14d6c678c",
      "custom_dfbdd903-5add-4aa6-98f0-3cb0cbcf240f",
      "custom_d0a8aad8-4ac7-4c79-b911-8f24e0213dda",
      "custom_33bd5b45-86a0-437e-a0d9-16d8988e741c",
      "custom_cd8e97a3-423b-4182-9364-1178b58e440d",
      "custom_56763015-c43e-423d-b94c-5e81b97b0df4",
      "custom_676d13ef-167c-4f98-8227-ceea9dd75860",
      "custom_71782b01-1167-4968-9e98-776166780ad9",
      "custom_e4b97389-1f3e-470a-b383-6b35209f0d24",
      "custom_b9535feb-59a0-4988-8b55-79a32a4e4341",
      "custom_260cfa04-936c-438f-8247-a406b1995516",
      "custom_2f3e9d48-5d0e-47b3-a90f-a605b8fb3a07",
      "custom_87ef5e1c-36e2-4321-8fff-dba4e6cb3f43"
    ],
    "hiddenIndices": [
      20,
      0,
      1,
      13,
      19
    ],
    "ordering": [
      14,
      17,
      3,
      2,
      6,
      4,
      7,
      8,
      10,
      5,
      12,
      13,
      0,
      1,
      9,
      11,
      15,
      16,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": 16,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_fcb6a472-ae49-439c-9a60-0c4b9b33bf71",
      "custom_1a836d3b-50b9-4bf0-879a-03af92997eff",
      "custom_d0a8aad8-4ac7-4c79-b911-8f24e0213dda"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      5,
      1,
      6
    ],
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": 30,
    "hiddenIds": [
      "custom_83c1671e-d606-4dfa-9a47-5784f1f5cadd"
    ],
    "orderedIds": [
      "custom_83c1671e-d606-4dfa-9a47-5784f1f5cadd",
      "custom_f3dec579-7ffb-4496-9ca0-8b591bd2f5e1",
      "custom_1a836d3b-50b9-4bf0-879a-03af92997eff",
      "custom_3f6179f8-652c-4192-b59f-f3e1d71c7466",
      "custom_87ef5e1c-36e2-4321-8fff-dba4e6cb3f43",
      "custom_346055df-0b08-4c63-89c0-bbc14d6c678c",
      "custom_7f9f639f-c241-466d-bf76-a044c0d31f9f",
      "custom_b304d9c2-f56d-4611-a791-3b2df62cd40c",
      "custom_35d6de51-6468-4808-adc9-4628b3bb05ad",
      "custom_96549e32-7188-4ea9-b057-c590247a8a24",
      "custom_08e03431-b3fd-4ac2-b2a4-edbae5abe776",
      "custom_429f08c1-d402-4e44-8abe-276111b4f923",
      "custom_57f0f0fc-b7ee-4490-a74d-faeb8fd7882a",
      "custom_4b4b980d-eb01-4878-a288-32202ddd5a72",
      "custom_8e4bea73-7a2b-46f2-8b70-bc8d149dff28",
      "custom_fcb6a472-ae49-439c-9a60-0c4b9b33bf71",
      "custom_dfbdd903-5add-4aa6-98f0-3cb0cbcf240f",
      "custom_d0a8aad8-4ac7-4c79-b911-8f24e0213dda",
      "custom_f4d6554b-f659-444e-87c9-e0bac1a0b72f",
      "custom_33bd5b45-86a0-437e-a0d9-16d8988e741c",
      "custom_cd8e97a3-423b-4182-9364-1178b58e440d",
      "custom_56763015-c43e-423d-b94c-5e81b97b0df4",
      "custom_676d13ef-167c-4f98-8227-ceea9dd75860",
      "custom_71782b01-1167-4968-9e98-776166780ad9",
      "custom_e4b97389-1f3e-470a-b383-6b35209f0d24",
      "custom_b9535feb-59a0-4988-8b55-79a32a4e4341",
      "custom_260cfa04-936c-438f-8247-a406b1995516",
      "custom_2f3e9d48-5d0e-47b3-a90f-a605b8fb3a07"
    ],
    "hiddenIndices": [
      53,
      46,
      47,
      45,
      42,
      37,
      30,
      28,
      39,
      36,
      50,
      31,
      29,
      32,
      38,
      52,
      34,
      33,
      10
    ],
    "ordering": [
      10,
      35,
      55,
      51,
      48,
      44,
      49,
      54,
      5,
      40,
      9,
      3,
      41,
      43,
      52,
      27,
      11,
      0,
      1,
      2,
      4,
      6,
      7,
      8,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      36,
      37,
      38,
      39,
      42,
      45,
      46,
      47,
      50,
      53
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0,
      "visible": false
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 0,
      "visible": false
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  }
};
